<template>
    <div>
        <tab name="2"></tab>		
		<el-alert type="warning" :closable="false">
		    <div slot="title">以下为等待转码的视频，不可编辑，请耐心等待转码完成，转码完成的视频会从当前列表消失，同时出现在【视频资源】列表</div>
		</el-alert>
        <div class="page-list-box">
            <el-table
                :data="dataList"
                border
                style="width: 100%"
                v-loading="listLoading"
                size="small"
                stripe
            >
                <el-table-column prop="createUser" label="用户ID"></el-table-column>
                <el-table-column prop="createUserName" label="用户名称" show-overflow-tooltip></el-table-column>
                <el-table-column prop="videoId" label="视频ID"></el-table-column>               
                <el-table-column prop="name" label="视频名称" min-width="120" show-overflow-tooltip></el-table-column>                
                <el-table-column prop="createTime" label="上传时间" min-width="150"></el-table-column> 
				<el-table-column  label="状态">
					<template slot-scope="scope">
						<p>上传状态：{{uploadStatus.get(scope.row.uploadStatus)}}</p>
						<p>转码状态：{{transcodeStatus.get(scope.row.transcodeStatus)}}</p>
					</template>
				</el-table-column> 
            </el-table>
        </div>
        <div v-if="data" class="page-pagination-box">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="getDataList"
                :current-page.sync="params.pageNo"
                :page-sizes="$pageSizes"
                :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="data.totalCount || 0">
            </el-pagination>
        </div>
        
    </div>
</template>

<script>
import Tab from '../components/tab';

export default {
    components:{Tab},
    data() {
        return{
			data: null,
			dataList: null,
			listLoading: false,			
			params:{
			    pageNo: 1,
			    pageSize: this.$pageSizes[0],
			},
        }
    },
	computed:{
	    uploadStatus(){
	        return new Map([
	            [1,'处理中'],
	            [2,'处理完成'],
	            [3,'处理失败'],
	            [4,'上传中'],
	            [5,'上传失败']
	        ])
	    },
	    transcodeStatus(){
	        return new Map([
				[0,'未转码'],
	            [1,'转码'],
	            [2,'转码成功'],
	            [3,'转码失败'],
	            [4,'提交转码失败'],
	            [5,'彻底转码失败'],
	            [6,'已提交转码'],
	        ])
	    }
	},
	mounted(){	   
	    this.getDataList();
	},
	methods:{
		//获取列表
		getDataList() {
		    this.listLoading = true;
		    this.$request({
		        url: "/video/task/list",
		        method: "POST",
		        data: {
		            ...this.params		            
		        },
		    })
		        .then((res) => {
		            const { state, msg, result } = res.data;
		            if (state == 1 && result) {
		                this.data = result;
		                this.dataList = result.result || [];
		            } else {
		                this.$message.error(msg || "请求失败");
		            }
		        })
		        .catch(() => {
		            this.$message.error("请求错误");
		        })
		        .finally(() => {
		            this.listLoading = false;
		        });
		},
		//选择pageSize
		handleSizeChange(e) {
		    this.params.pageNo = 1;
		    this.params.pageSize = e;
		    this.getDataList();
		},
	}
}
</script>